export const isRadioPageLoaded = (entityName, entityData) => (
    entityData && entityData.entityName === entityName && !entityData.isLoading
);
